export default __webpack_public_path__ + "static/media/clutch-ignition-protectors.2b6061fc.jpg";